import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { memo as i } from "react";
import d from "clsx";
import { cn as r } from "../../utils/cn.js";
const c = i(({ label: l, icon: n, onClick: o, active: e, disabled: a }) => /* @__PURE__ */ s(
  "button",
  {
    className: "flex flex-1 flex-col items-center justify-center gap-1 p-3",
    disabled: a,
    type: "button",
    onClick: o,
    children: [
      /* @__PURE__ */ t("div", { className: r({ "stroke-text-secondary flex fill-none": !0, "stroke-accent fill-icon-fill": e }), children: n }),
      /* @__PURE__ */ t(
        "div",
        {
          className: d({
            "text-caption-2 text-nowrap font-medium": !0,
            "text-text-secondary": !e,
            "text-accent": e
          }),
          children: l
        }
      )
    ]
  }
));
c.displayName = "MenuButton";
const p = ({ standalone: l, items: n, className: o }) => /* @__PURE__ */ t(
  "nav",
  {
    className: r({
      "bg-background border-separator z-10 w-full border-t": !0,
      "pb-2": l
    }, o),
    children: /* @__PURE__ */ t("div", { className: "flex w-full justify-between", children: n.filter((e) => !e.hidden).map((e) => /* @__PURE__ */ t(
      c,
      {
        active: e.active,
        disabled: e.disabled,
        icon: e.icon,
        label: e.label,
        onClick: e.onClick
      },
      e.label
    )) })
  }
);
export {
  p as Menu
};
//# sourceMappingURL=index.js.map
